import { useMutation } from '@tanstack/react-query';
import { confirmPasswordReset } from '../../api';

export function useConfirmPasswordReset() {
  return useMutation({
    mutationFn: ({ token, password }: { token: string; password: string }) => confirmPasswordReset(token, password),
  });
}
